import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  Avatar,
  Box,
  Button,
  Chip,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import * as React from "react";
import DateRangePickerComponent from "../../../components/date/DateRangePickerComponent";
import rightCaret from '../../../assets/images/icons/rightCaret.svg'
import DeleteIcon from "../../../assets/images/icons/X.svg";
import FilterIcon from '../../../assets/images/icons/filterIcon.svg'
import moment from "moment/moment";
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { io } from 'socket.io-client';
import CommonModel from '../../../components/dialog/Common';
import SearchInput from "../../../components/inputs/searchInput";
import useDebounce from '../../../hooks/use.debounce';
import { capitalizeWords, DELIVERABLES_DATA, formatDate, getCompanyid, getFormatedDate, SELECTED_DELI, SELECTED_DELI_FOR_YOUTUBE } from '../../../utils/common';
import { BASE_URL, CAMPAIGN_STATUS, CAMPAIGN_TYPES, DRAFT, GENDER, MY_CAMPAIGNS_SEARCH_FILTERS, PENDING, REJECTED, SOCKET_EVENT } from '../../../utils/constant';
import { endpoints } from '../../../utils/endpoints';
import { getAllBrandForDropDown } from '../../brands/action';
import { getCampaignByIdForDetailsPage, getMyCampaigns } from "../action";
import { updateCampaign } from "../campaignSlice";
import CustomPagination from '../../../utils/CustomPagination';
import plusIcon from '../../../assets/images/icons/plusIcon.svg'
import { styled } from '@mui/material/styles';
import searchIcon from "../../../assets/images/icons/searchIcon.svg"
const CustomSearchInput = styled(SearchInput)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "50px !important",
  },
  "& input": {
    padding: '0px !important', paddingLeft: '0px !important'
  }
});
function EnhancedTableHead(props) {
  const { order, orderBy } = props;

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Name",
      type: "",
    },
    {
      id: "brand",
      numeric: false,
      disablePadding: true,
      label: "Brand",
      type: "",
    },
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: "Type",
      type: "",
    },
    {
      id: "publishDuration",
      numeric: false,
      disablePadding: true,
      label: "Duration",
      type: "",
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      label: "Product Name",
      type: "",
    },
    {
      id: "deliverables",
      numeric: false,
      disablePadding: true,
      label: "Posted On",
      type: "",
    },
    {
      id: "Gender",
      numeric: false,
      disablePadding: true,
      label: "Gender",
      type: "",
    },
    {
      id: "follower",
      numeric: false,
      disablePadding: true,
      label: "Followers",
      type: "",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      type: "",
    },
  ];

  return (
    <TableHead className="hideActionSort">
      <TableRow sx={{ background: '#DBECFF !important', height: "50px", "& th": { backgroundColor: "inherit !important" }, }}>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}>
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default function MyCampaigns() {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [modelOpen, setModelOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const tableRef = React.useRef();
  const {
    limit,
    page,
    sort_key,
    totalPages,
    myCampaigns,
    myCampaignsFilters
  } = useSelector((state) => state.campaignSlice);

  const {
    brandsDropdown
  } = useSelector((state) => state.brandSlice);

  const {
    plateforms
  } = useSelector((state) => state.commonSlice);
  const socket = io(BASE_URL + endpoints.ims, {
    path: '/stream',
    transports: ['websocket']
  });

  const debouncedSearch = useDebounce(myCampaignsFilters?.search, 500);

  useEffect(() => {
    dispatch(updateCampaign({ page: 0, limit: 10 }));
    dispatch(getMyCampaigns());
    dispatch(getAllBrandForDropDown(getCompanyid()))
  }, []);

  const handleSearch = (event) => {
    dispatch(updateCampaign({ myCampaignsFilters: { ...myCampaignsFilters, search: event.target.value } }));
  };

  const handleMenuOpen = (event) => {
    if (anchorEl) return;
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const handleCampaignCreated = () => {
      return dispatch(getMyCampaigns());
    };

    const handleCampaignApproved = () => {
      return dispatch(getMyCampaigns());
    };

    socket.on(SOCKET_EVENT.CAMPAIGN_CREATED, handleCampaignCreated);
    socket.on(SOCKET_EVENT.CAMPAIGN_APPROVED, handleCampaignApproved);

    // Cleanup the event listeners on component unmount
    return () => {
      socket.off(SOCKET_EVENT.CAMPAIGN_CREATED, handleCampaignCreated);
      socket.off(SOCKET_EVENT.CAMPAIGN_APPROVED, handleCampaignApproved);
    };
  }, [socket]);

  useEffect(() => {
    if (myCampaignsFilters?.search || myCampaignsFilters?.search == '')
      dispatch(getMyCampaigns());
  }, [debouncedSearch]);

  const handleSearchClear = () => {
    dispatch(updateCampaign({ myCampaignsFilters: { ...myCampaignsFilters, search: "" } }));
    dispatch(getMyCampaigns());
  };

  const updateFormData = (row) => {
    dispatch(getCampaignByIdForDetailsPage(row.id, (data) => {
      delete data.campaignContent;
      delete data.applied;
      delete row.applied;
      let rowData = data;
      rowData.campaignId = row.id;
      const selectedDeliverables = rowData?.deliverables?.length > 0 ? (rowData?.deliverables[0]?.plateform == "youtube" ? SELECTED_DELI_FOR_YOUTUBE : SELECTED_DELI).map((vv) => {
        let val = data?.deliverables?.map((v) => v.deliverables)[0]?.find((v) => v?.type == vv?.type);
        if (val) {
          return { ...val };
        } else {
          return vv;
        }
      }) : [];
      rowData.platform = rowData?.deliverables?.length > 0 ? rowData?.deliverables[0]?.plateform : "";
      rowData.selectedDeliverables = rowData?.deliverables?.length > 0 ? selectedDeliverables : [];
      rowData.post = rowData?.deliverables?.length > 0 ? data?.deliverables[0]?.post : [];
      rowData.deliverables = rowData?.deliverables?.length > 0 ? DELIVERABLES_DATA.find((v) => v[`${rowData.deliverables[0].plateform}`])[`${rowData.deliverables[0].plateform}`] : [];
      rowData.brandId = row?.brandId || '';
      rowData.additionalRequirement = rowData.additionalRequirement !== "null" ? rowData.additionalRequirement : "";
      rowData.startDate = rowData.startDate ? formatDate(rowData.startDate) : null;
      rowData.endDate = rowData.endDate ? formatDate(rowData.endDate) : null;
      rowData.budgetbudgetPerInfluencer = rowData.budgetPerInfluencer;
      rowData.gender = rowData?.creator?.gender || "";
      rowData.creatorLocation = rowData?.creator?.creatorLocation || '';
      rowData.influncerType = rowData?.creator?.influncerType || "";
      rowData.selectedCategories = rowData?.creator?.selectedCategories || [];
      rowData.campaignApplyingPreferences = rowData?.creator?.campaignApplyingPreferences ? ['campaignApplyingPreferences'] : [];
      rowData.noOfCreators = String(rowData?.noOfCreators || "");
      rowData.bannerImage = row?.bannerImage?.toString() || '';
      rowData.shipmentDetails = rowData.shipmentDetails ? ['shipmentDetails'] : []
      rowData.productShipmentDate = rowData.productShipmentDate ? formatDate(rowData.productShipmentDate) : "";
      rowData.conceptScriptDate = rowData?.conceptScriptDate ? formatDate(rowData?.conceptScriptDate) : null;
      rowData.contentSubmissionDate = rowData?.contentSubmissionDate ? formatDate(rowData?.contentSubmissionDate) : null
      rowData.contentPublishDate = rowData?.contentPublishDate ? formatDate(rowData?.contentPublishDate) : null;
      rowData.mode = "edit";
      rowData.productDropdown = brandsDropdown?.find((v) => v.id === rowData.brandId)?.product?.map((v) => v?.name) || [];
      dispatch(updateCampaign({ affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, formData: rowData }));
      navigate(`/campaign/info`)
    }))
  }

  const handleChange = (value) => {
    dispatch(updateCampaign({ page: value - 1 }));
    dispatch(getMyCampaigns());
  };

  const menuData = [
    {
      label: "Brands",
      children: [],
      key: 'brandId'
    },
    {
      label: "Status",
      children: [],
      key: 'status'
    },
    {
      label: "Posted On",
      children: [
        // { label: "All", value: '', key: 'deliverables' },
      ],
      key: 'deliverables'
    },
    {
      label: "Type",
      children: [],
      key: 'type'
    },
    {
      label: "Gender",
      children: [],
      key: 'gender',
    },
  ];

  menuData?.map((item) => {
    if (item.label === 'Brands') {
      const genders = brandsDropdown?.map((g) => ({ label: g.brandName, value: g.id, key: 'brandId' }));
      item.children = [...item.children, ...genders]
    }
    if (item.label === 'Status') {
      const genders = CAMPAIGN_STATUS?.map((g) => ({ label: g, value: g, key: 'status' }));
      item.children = [...item.children, ...genders]
    }
    if (item.label === 'Posted On') {
      const genders = plateforms?.map((g) => ({ label: g, value: g, key: 'deliverables' }));
      item.children = [...item.children, ...genders]
    }
    if (item.label === 'Type') {
      const genders = Object.values(CAMPAIGN_TYPES)?.map((g) => ({ label: capitalizeWords(g), value: g, key: 'type' }));
      item.children = [...item.children, ...genders]
    }
    if (item.label === 'Gender') {
      const genders = GENDER?.map((g) => ({ label: g, value: g, key: 'gender' }));
      item.children = [...item.children, ...genders]
    }
    return item;
  })

  return (
    <>
      <Stack direction={"column"} gap={2}>
        <Stack
          className="mainTitle flex-wrap"
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            minHeight: '42px',
            paddingX: '16px'
          }}>
          <Typography className="page-title" variant="h1">My Campaigns</Typography>
          <button className="btnPrimary d-flex justify-content-center align-items-center flex-row"
            onClick={() => {
              if (brandsDropdown.length === 0) {
                setModelOpen(true);
              } else {
                dispatch(updateCampaign({ formData: {}, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0 }))
                navigate("/campaign/type");
              }
            }}>
            <img src={plusIcon} alt="plusIcon" width={20} height={20} />&nbsp;Create Campaign
          </button>
        </Stack>
        <CommonModel
          open={modelOpen}
          handleDialogClose={() => setModelOpen(false)}
          dialogTitle={""}
          dialogPara={`This company is not affiliated with any brands.`}
          nvCancel={""}
          yesHandle={() => {
            setModelOpen(false)
          }}
        />
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            overflow: 'none',
          }}>
          <Stack sx={{padding:'16px'}} direction="row" >
            <Stack direction="row" gap={1.5} justifyContent={{lg:'flex-start',md:"flex-start"}} alignItems={{lg:'center',md:"center"}} flexWrap="wrap" sx={{width:{lg:'60%',md:'60%',sm:'65%'}}}>
              <Button onClick={handleMenuOpen} sx={{
                "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                height: '40px', width: '108px',
                alignItems: 'center', display: 'flex', gap: '4px', borderRadius: '50px',
                padding: '0px', border: '1px solid #F0F0F0', color: 'black', "&:hover": { backgroundColor: 'transparent !important' }
              }}>
                <img src={FilterIcon} alt="filtericon" width={20} height={20} />
                <Typography sx={{ fontWeight: '500 !important', fontSize: '16px !important', p: 0, m: 0, fontFamily: 'var(--family1)', whiteSpace: 'nowrap', }}>Filter</Typography></Button>
                {MY_CAMPAIGNS_SEARCH_FILTERS?.filter((item) => myCampaignsFilters[item.key]).map((f) => (
                  <>
                    <Chip
                      key={f}
                      label={f.name + ': ' + (
                        myCampaignsFilters[f.key] === "" 
                          ? 'All' 
                          : (() => {
                              const value = f.key === 'brandId' 
                                ? brandsDropdown?.find((i) => i.id === myCampaignsFilters[f.key])?.brandName 
                                : myCampaignsFilters[f.key];
                      
                              if (!value) return '';
                      
                              const capitalizedValue = capitalizeWords(value);
                              return capitalizedValue.length > 5 
                                ? capitalizedValue.substring(0, 5) + '...' 
                                : capitalizedValue;
                            })()
                      )}
                      variant="outlined"
                      onClick={() => { }}
                      onDelete={() => {
                        dispatch(updateCampaign({ myCampaignsFilters: { ...myCampaignsFilters, [f.key]: f.value || "" }, page: 0 }));
                        dispatch(getMyCampaigns());
                      }}
                      deleteIcon={
                        <img src={DeleteIcon} alt="delete icon" height={24} width={24} />
                      }
                      sx={{ borderRadius: '5px', border: '1px solid var(--color-blue)', color: 'var(--color-blue)', }}
                    />
                  </>
                ))
                }
            </Stack>
            <Stack direction="row" gap={2} alignItems="center" justifyContent="flex-end" className='allFilter cFilter' sx={{width:{lg:'40%',md:'40%',sm:'35%'},height:'100%'}}>
              <CustomSearchInput
                className="inputSearch sContrl p-0"
                value={myCampaignsFilters?.search}
                placeholder={"Search here..."}
                handleSearch={handleSearch}
                clearSearch={handleSearchClear}
                startAdornment={
                  <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                    sx={{
                      maxHeight: 'none',
                      height: '38px',
                      minWidth: '38px',
                      marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                    }}>
                    <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                  </InputAdornment>
                } />
              <DateRangePickerComponent text="Date Range" getSelectedDate={(dates) => {

                if (dates?.filter((v) => v)?.length === 2) {
                  dispatch(updateCampaign({ myCampaignsFilters: { ...myCampaignsFilters, startDate: getFormatedDate(dates[0]), endDate: getFormatedDate(dates[1]) } }));
                  dispatch(getMyCampaigns());
                }

              }} dateReset={myCampaignsFilters} startDate1={myCampaignsFilters.startDate} endDate1={myCampaignsFilters.endDate} />
              <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692' }}
                onClick={() => {
                  dispatch(updateCampaign({ myCampaignsFilters: {} }))
                  dispatch(getMyCampaigns());
                }} />
            </Stack>
          </Stack>
          <TableContainer stickyHeader ref={tableRef}>
            <Table stickyHeader aria-label="sticky table">
              <EnhancedTableHead
                order={order}
                orderBy={sort_key}
                onRequestSort={() => { }}
                numSelected={0}
                onSelectAllClick={function () {
                  throw new Error("Function not implemented.");
                }} />
              <TableBody>
                {myCampaigns && myCampaigns?.length ? (
                  myCampaigns?.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row?.id}
                        className={"tableRow"}
                        sx={{
                          "&:hover": {
                            backgroundColor: '#F0F7FF !important', "& td": {
                              backgroundColor: "inherit !important"
                            },
                          }, height: '60px'
                        }}>
                        <TableCell component="td" scope="row" padding="none">
                          <Link className="text-decoration-none" style={{ fontSize: '14px', fontWeight: '500', letterSpacing: '0px' }} onClick={(e) => {
                            e.preventDefault();
                            navigate(`/campaign/partial/details/${row.id}`, { state: row });
                          }} >{row?.name || "N/A"}</Link>
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none" sx={{ textTransform: "uppercase" }}>
                          {row?.brandName || "N/A"}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none" className='capitalize-first-letter'>
                          {row?.type || "N/A"}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none">
                          {moment(row?.startDate).format("DD MMM")}{" - "}{moment(row?.endDate).format("DD MMM")}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none">
                          {row?.products?.map((v) => v.name)?.toString() || "N/A"}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none">
                          {row?.deliverables?.length > 0 ? row?.deliverables?.map((item) => item.plateform)?.toString() : "N/A"}
                        </TableCell>
                        <TableCell align="left" className="single-line">
                          {row?.creator?.gender || "N/A"}
                        </TableCell>
                        <TableCell align="left" className="single-line">
                          {row?.creator?.influncerType?.toString() || "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                        </TableCell>
                        <TableCell>
                          <Stack direction={"row"} style={{ gap: '8px' }}>
                            {[DRAFT, PENDING, REJECTED].includes(row.status) &&
                              <div className='actBtnGrps'>
                                <span className='editIcon' onClick={() => updateFormData(row)}>Edit</span>
                              </div>
                            }
                            <span className='viewIcon' onClick={() => navigate(`/campaign/partial/details/${row.id}`, { state: { type: row.type } })}>View</span>
                          </Stack>
                        </TableCell>
                      </TableRow >
                    );
                  })
                ) : (
                  <TableRow colSpan={10}>
                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                      <Typography
                        color="inherit"
                        variant="subtitle1"
                        alignItems={"center"}
                        component="h3">
                        No Data found!
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody >
            </Table >
          </TableContainer >
          <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / limit) || 0}
              onChange={handleChange}
              currentPage={page}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
        </Box >
      </Stack >
      {Boolean(anchorEl) && (<NestedMenu menuItems={menuData} parentAnchorEl={anchorEl} onClose={handleMenuClose} />)}
    </>
  );
}

const NestedMenu = React.memo(({ menuItems, parentAnchorEl, onClose, depth = 0, marginMenuLeft = '0' }) => {
  const [openMenus, setOpenMenus] = React.useState({});
  const dispatch = useDispatch();
  const {
    myCampaignsFilters
  } = useSelector((state) => state.campaignSlice);

  const handleMenuClick = (event, index) => {
    setOpenMenus((prev) => ({
      ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: null }), {}), // Close all other menus
      [index]: prev[index] ? null : event.currentTarget,
    }));
  };

  const handleItemClick = (event, item, index) => {
    if (item.children) {
      handleMenuClick(event, index);
    } else {
      switch (item.key) {
        case 'brandId':
        case 'gender':
        case 'type':
        case 'deliverables':
        case 'status':
          dispatch(updateCampaign({ myCampaignsFilters: { ...myCampaignsFilters, [item.key]: item.value || "" }, page: 0 }));
          dispatch(getMyCampaigns());
          break;
        default:
      }
      onClose();
    }
  };

  return (
    <>
      {<Menu
        disablePortal
        className="custom-filter-discovery"
        anchorEl={parentAnchorEl}
        open={Boolean(parentAnchorEl)}
        onClose={onClose}
        sx={{
          maxHeight: '350px', marginLeft: `${marginMenuLeft}`,
          borderRadius: '12px',
        }}
        anchorOrigin={
          depth === 0
            ? { vertical: "bottom", horizontal: "left" }
            : { vertical: "top", horizontal: "right" }
        }
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {menuItems.map((item, index) => (
          <>
            <MenuItem
              sx={{
                borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
              }}
              key={`${depth}-${index}`}
              onClick={(event) => {
                handleItemClick(event, item, index);
              }}
              value={item.value || ""}
              defaultValue=""
            >
              <Box sx={{ flexGrow: 1, px: 2, textAlign: 'left' }}>{item.label}</Box>
              {item.children && <Box sx={{ pr: 2 }}><Avatar src={rightCaret} alt="caret" sx={{ height: '20px', width: '20px', }} /></Box>}
            </MenuItem>
            {item.children && (
              <NestedMenu
                marginMenuLeft="5px"
                menuItems={item.children}
                parentAnchorEl={openMenus[index]}
                onClose={() => setOpenMenus((prev) => ({ ...prev, [index]: null }))}
                depth={depth + 1}
              />
            )}
          </>
        ))}
      </Menu>}
    </>
  );
});